import { useLang } from "@/i18n/LangContext";
import { useContent } from "@/context/SiteContext";
import { Container, Eyebrow, LLink, ArrowLink } from "@/components/common";
import { Reveal, LineReveal } from "@/components/motion/Reveal";

const DISH = "/images/restaurante/restaurante_comedor.webp";
const BREAKFAST = "/images/restaurante/restaurante_detalle.webp";

export function Gastronomy() {
  const { t, lang } = useLang();
  const c = useContent();
  return (
    <section data-testid="home-gastronomy" className="bg-sand py-20 md:py-32">
      <Container>
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-8 items-center">
          <div className="lg:col-span-7 grid grid-cols-12 gap-4 md:gap-6">
            <Reveal className="col-span-8 img-zoom aspect-[4/5]">
              <img src={DISH} alt="Cocina mediterránea del restaurante" loading="lazy" className="h-full w-full object-cover" />
            </Reveal>
            <Reveal delay={0.15} className="col-span-4 self-end img-zoom aspect-[3/4]">
              <img src={BREAKFAST} alt="Mesa del restaurante con copas azules" loading="lazy" className="h-full w-full object-cover" />
            </Reveal>
          </div>
          <div className="lg:col-span-5 lg:pl-8">
            <Reveal><Eyebrow className="mb-6">{t.home.restEyebrow}</Eyebrow></Reveal>
            <LineReveal as="h2" lines={t.pages.homeHeadings.gastronomy} className="font-serif text-3xl sm:text-4xl lg:text-5xl leading-[1.08] tracking-tight text-charcoal" />
            <Reveal delay={0.15}>
              <p className="mt-8 text-base md:text-lg leading-relaxed text-charcoal/70">{c("rest_desc", lang)}</p>
              <ul className="mt-8 space-y-3 border-t border-line pt-6">
                {t.restaurant.menus.slice(0, 3).map((m) => (
                  <li key={m.t} className="flex items-baseline justify-between gap-6 text-sm">
                    <span className="text-charcoal">{m.t}</span>
                    <span className="flex-1 border-b border-dotted border-line-md" />
                    <span className="font-mono text-[10px] uppercase tracking-[0.15em] text-charcoal/50">{m.p}</span>
                  </li>
                ))}
              </ul>
              <LLink to="restaurant" data-testid="gastronomy-cta" className="mt-8 inline-block"><ArrowLink>{t.home.restCta}</ArrowLink></LLink>
            </Reveal>
          </div>
        </div>
      </Container>
    </section>
  );
}
